<template>
  <div class="study-executives-contents">
    <div v-if="!loader">
      <b-row>
        <b-colxx xxs="12">
          <div class="separator mb-5"></div>
        </b-colxx>
      </b-row>

      <!-- Header dropdown filter -->
      <b-row>
        <b-colxx xxs="12" class="mb-4 pl-0">
          <header-drop-down-filter
            :leftHeaderText="leftHeaderTextValue"
            :sites="allSitesList"
            :countries="countryList"
            :callApiCompleted="callApiCompleted"
            :checkedSitesApply="sitesSelected == 'all' ? allSitesList : sitesSelected"
            :checkedCountriesApply="countrySelected == 'all' ? countryList : countrySelected"
            :exportBtn="true"
            :participantsBtn="true"
            :fpiBtn="true"
            :todayDate="todaysDate"
            @onApplyCountry="getDataFromCountry"
            @onApplySites="getDataFromSite"
            @onApplyFpi="filter"
            @onPageSelection="getSelectedPage"
            @onApplyParticipants="getParticipantsDataFromCheckbox"
            @onFetchedParticipants="fetchedParticipants"
            :dataPicker="dataPicker"
            @onApplyRangeMonth="getRangeMonth"
            v-if="studyData"
            :specificSiteId="specificSiteId"
            :siteListInParticipants="siteListInParticipants"
            :zoomGraphValue="zoomGraphValue"
            :studyData="studyData"
            :toggleFeatures="toggleFeatures"
          ></header-drop-down-filter>
        </b-colxx>
      </b-row>
      <!-- End header dropdown filter -->

      <!-- Only show when zoomGraph -->
      <div v-if="zoomGraphValue" @click="zoomGraphValue = ''" class="mb-10 color_4c8ce4 expand-back">
        <i class="fa fa-caret-left" aria-hidden="true"></i>
        Back
      </div>
      <!-- End show when zoomGraph -->

      <!-- Maps Chart -->
      <b-row class="" v-show="zoomGraphValue === '' || zoomGraphValue === 'study-participant-status-maps' || zoomGraphValue === 'percentage-participant'">
        <b-colxx v-if="isMapsApiAvailable" :class="zoomGraphValue === 'study-participant-status-maps' ? 'col-xl-12 study-participant-status-maps-zoom' : specificSiteId && specificSiteId.length === 0 ? 'col-xl-12' : 'col-xl-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'study-participant-status-maps'" lg="12" md="12" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <StudyParticipantStatusMaps
            titleChart="Study Participant Status"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'study-participant-status-maps'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            containerId="blank"
            :rawData="rawParticipantStatus"
            :titleDate="toDate || todaysDate"
            :specificSiteId="specificSiteId"
            :dataLoaded="dataLoaded.rawParticipantStatus"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
          />
        </b-colxx>
        <!-- End Maps Chart -->

        <!-- Percentage participant status chart -->
        <b-colxx :class="zoomGraphValue === 'percentage-participant' ? 'col-xl-12 percentage-participant-zoom' : !isMapsApiAvailable && (!specificSiteId || specificSiteId.length === 0) ? 'col-xl-12' : 'col-xl-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'percentage-participant'" lg="12" md="12" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <PercentageParticipantByStatus
            containerId="blank"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'percentage-participant'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :fromDate="fromDate"
            :toDate="toDate"
            :studyID="studyId"
            titleChart="Percentage of Participants by Status as of"
            :titleDate="toDate || todaysDate"
            :filterTriggered="filterTriggered"
            :rawData="rawParticipantStatus"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :dataLoaded="dataLoaded.rawParticipantStatus"
          />
        </b-colxx>
        <!-- End of percentage participant status chart -->

        <!-- Top 5 site with most active participant list -->
        <b-colxx v-if="specificSiteId && specificSiteId.length === 0" :class="zoomGraphValue === 'mostactive-participant' ? 'col-xl-12 mostactive-participant-zoom' : 'col-xl-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'mostactive-participant'" xl="6" lg="12" md="12" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <TopFiveMostActiveParticipant
            containerId="blank"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'mostactive-participant'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :fromDate="fromDate"
            :toDate="toDate"
            titleChart="Top 5 Sites with Most Active Participants"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :titleDate="toDate || todaysDate"
            :filterTriggered="filterTriggered"
            :rawData="rawParticipantStatus"
            :dataLoaded="dataLoaded.rawParticipantStatus"
          />
        </b-colxx>
        <!-- End of top 5 site with most active participant list -->
      </b-row>

      <!-- Study enrollment progress chart -->
      <b-row class="" v-show="zoomGraphValue == '' || zoomGraphValue == 'enrollment-sum'">
        <b-colxx xl="12" lg="12" md="12" class="pl-0 pb-10" style="transition-duration: 0.2s" :class="zoomGraphValue === 'enrollment-sum' ? 'enrollment-sum-zoom' : ''">
          <enrollment-sum
            containerId="enrollmentSum"
            :rawData="studyEnrollmentRawData"
            :zoomGraphValue="zoomGraphValue"
            :specificSiteId="specificSiteId"
            titleChart="Study Enrollment Progress PPM (Participants per Month)"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :studyId="studyId"
            :fromDate="fromDate"
            :toDate="toDate"
            :monthSelected="monthSelected"
            v-on:zoomEnabled="zoomGraphValue = 'enrollment-sum'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :dataLoaded="dataLoaded['studyEnrollmentRawData'] || false"
          ></enrollment-sum>
        </b-colxx>
      </b-row>
      <!-- End of study enrollment progress chart -->

      <b-row v-if="specificSiteId && specificSiteId.length === 0" class="" v-show="zoomGraphValue === '' || zoomGraphValue === 'top-five-site-participant'">
        <!-- Top 5 site participant enrollment -->
        <b-colxx xl="6" lg="6" md="12" class="pl-0 pb-10">
          <TopFiveSiteParticipantEnrollment
            containerId="blank"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'top-five-site-participant'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            titleChart="Top 5 Sites for Participant Enrollment"
            :specificSiteId="specificSiteId"
            :fromDate="fromDate"
            :toDate="toDate"
            :sitesSelected="sitesSelected"
            :studyEnrollmentRawData="studyEnrollmentRawData"
            :dataLoaded="dataLoaded['studyEnrollmentRawData'] || false"
          />
        </b-colxx>
        <!-- End of top 5 site participant enrollment -->

        <!-- Top 5 country participant -->
        <b-colxx xl="6" lg="6" md="12" class="pl-0 pb-10">
          <TopFiveCountryParticipantEnrollment
            containerId="blank"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'top-five-country-participant'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            titleChart="Top 5 Countries for Participant Enrollment"
            :specificSiteId="specificSiteId"
            :fromDate="fromDate"
            :toDate="toDate"
            :countrySelected="countrySelected"
            :studyEnrollmentRawData="studyEnrollmentRawData"
            :dataLoaded="dataLoaded['studyEnrollmentRawData'] || false"
          />
        </b-colxx>
        <!-- End of top 5 country participant -->
      </b-row>

      <b-row v-if="complianceWidgets" v-show="zoomGraphValue === '' || zoomGraphValue === 'compliance-data' || zoomGraphValue === 'completion-data'">
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'completion-data'" :class="zoomGraphValue === 'completion-data' ? 'col-xl-12 completion-data-zoom' : 'col-xl-6'" lg="6" md="6" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <!-- Create completion chart here -->
          <ActivitiesCompletionCard
            titleChart="Study Activity Completion by Day"
            :data="completionData"
            :participantData="completionDataByParticipant"
            :zoomGraphValue="zoomGraphValue"
            @zoomEnabled="zoomGraphValue = 'completion-data'"
            @zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :studyId="studyId"
            :fromDate="fromDate"
            :toDate="toDate"
            :siteListInParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.completionData"
            :participantsSelected="participantsSelected"
          />
        </b-colxx>
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'compliance-data'" :class="zoomGraphValue === 'compliance-data' ? 'col-xl-12 compliance-data-zoom' : 'col-xl-6'" lg="6" md="6" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <!-- Create compliance chart here -->
          <ActivitiesComplianceCard
            titleChart="Study Activity Compliance by Day"
            :data="complianceData"
            :participantData="complianceDataByParticipant"
            :zoomGraphValue="zoomGraphValue"
            @zoomEnabled="zoomGraphValue = 'compliance-data'"
            @zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :studyId="studyId"
            :fromDate="fromDate"
            :toDate="toDate"
            :siteListInParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.complianceData"
            :participantsSelected="participantsSelected"
          />
        </b-colxx>
      </b-row>

      <b-row class="" v-if="complianceWidgets && specificSiteId && specificSiteId.length === 0">
        <b-colxx :class="zoomGraphValue === 'non-compliance-vs-retention-rate' ? 'col-lg-12 non-compliance-vs-retention-rate-zoom' : 'col-lg-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'non-compliance-vs-retention-rate'" class="pl-0 pb-10" style="transition-duration: 0.2s" v-if="specificSiteId && specificSiteId.length === 0">
          <NonComplianceVSRetentionRate
            titleChart="Non-Compliance % vs. Participant Retention Rate"
            :zoomGraphValue="zoomGraphValue"
            downloadId="non-compliance-vs-retention-rate"
            v-on:zoomEnabled="zoomGraphValue = 'non-compliance-vs-retention-rate'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :rawData="nonComplianceRateVSRetentionRateData"
            :dataLoaded="dataLoaded.nonComplianceRateVSRetentionRate"
          />
        </b-colxx>
      </b-row>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import _has from "lodash/has";
import _ from "lodash";
import { mapGetters } from "vuex";
import * as d3 from "d3";
import HeaderDropDownFilter from "../form-components/header-drop-down-filter";
import Loading from "vue-loading-overlay";

import StudyParticipantStatusMaps from "../containers/study-participant-status-maps";
import PercentageParticipantByStatus from "../containers/percentage-participant-by-status-card";
import TopFiveMostActiveParticipant from "../containers/top-five-most-active-participant";
import TopFiveSiteParticipantEnrollment from "../containers/top-five-site-participant-enrollment";
import TopFiveCountryParticipantEnrollment from "../containers/top-five-country-participant-enrollment";
import ActivitiesCompletionCard from "../containers/activities-completion-card";
import ActivitiesComplianceCard from "../containers/activities-compliance-card";
import NonComplianceVSRetentionRate from "../containers/non-compliance-vs-retention-rate.vue";
import EnrollmentSum from "../containers/enrollment-sum";
import * as utils from "../../services/visualization/utils";
import * as commonHelper from "@/components/services/common-helper";

import "vue-loading-overlay/dist/vue-loading.css";
import { AclRule } from "vue-acl";

import { PI, STUDY_COORDINATOR } from "@/constants/authRoles";
Vue.use(Loading);

const convertArrToString = arrObj => {
  let resultString = ``;
  if (arrObj && arrObj.length > 0) {
    arrObj.forEach(o => {
      resultString += `${o},`;
    });
    resultString = resultString.slice(0, -1);
  }
  return resultString;
};

export default {
  components: {
    HeaderDropDownFilter,
    StudyParticipantStatusMaps,
    PercentageParticipantByStatus,
    TopFiveMostActiveParticipant,
    TopFiveSiteParticipantEnrollment,
    TopFiveCountryParticipantEnrollment,
    ActivitiesComplianceCard,
    ActivitiesCompletionCard,
    NonComplianceVSRetentionRate,
    EnrollmentSum,
    "enrollment-sum": EnrollmentSum
  },
  props: {
    toggleFeatures: { type: Array, default: () => [] },
    complianceWidgets: { type: Boolean, default: false },
    studyData: { type: Object, default: null }
  },
  data() {
    return {
      studyId: null,
      filterTriggered: false,
      leftHeaderTextValue: "Study Performance Dashboard",
      allSitesList: [],
      countryList: [],
      siteListInParticipants: [],
      sitesSelected: ["all"],
      countrySelected: "all",
      participantsSelected: ["all"],
      callApiCompleted: null,
      todaysDate: "",
      dataPicker: [],
      firstFromDate: null,
      firstToDate: null,
      monthSelected: [],
      fromDate: null, //fromDate and toDate is a string value for date filter. Format would be YYYY-MM-DD
      toDate: null,
      specificSiteId: null, // for rbac feature
      zoomGraphValue: "",
      boundariesList: null,
      statusSelected: { label: "Active", value: "active" },
      choosenCountries: [],
      rawParticipantStatus: null,
      queriesRaw: null,
      complianceData: [],
      completionData: [],
      complianceDataByParticipant: [],
      completionDataByParticipant: [],
      loader: null,
      isLoading: true,
      studyEnrollmentSeries: null,
      studyEnrollmentRawData: null,
      dataLoaded: {},
      tmpCountries: [],
      tmpSites: [],
      tmpParticipants: [],
      sitesDetails: null,
      tmpStudyEnrollmentRawData: null,
      nonComplianceRateVSRetentionRateData: null
    };
  },

  watch: {
    tmpCountries: function(val) {
      // Do logic here
      const allCountries = _.uniq(val);
      this.countryList = _.orderBy(Array.from(allCountries), [country => country.toLowerCase()]);
    },

    tmpSites: function(val) {
      // Do logic here
      const allSites = _.uniq(val);
      this.allSitesList = _.orderBy(Array.from(allSites), [site => site.toLowerCase()]);
    },

    tmpParticipants: function(val) {
      // Do logic here
      const allParticipants = _.uniq(val);
      this.participantsSelected = _.orderBy(Array.from(allParticipants), [participant => participant.toLowerCase()]);
    },
    complianceWidgets: function(newValue) {
      if (newValue) {
        this.getNonComplianceRateVSRetentionRate().then(raws => {
          if (raws) {
            const countries = utils.getCountries(raws);
            const sites = utils.getSites(raws, countries);
            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.nonComplianceRateVSRetentionRateData = raws;
            this.dataLoaded.nonComplianceRateVSRetentionRate = true;
          }
        });
        this.getComplianceData().then(raws => {
          if (raws) {
            const countries = utils.getCountriesFromD3NestResult(raws);
            const sites = utils.getSitesFromD3NestResult(raws, countries);

            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.complianceData = raws;
            this.completionData = raws;
            this.dataLoaded.completionData = true;
            this.dataLoaded.complianceData = true;
          }
        });
        this.getParticipantComplianceData().then(raws => {
          if (raws) {
            const countries = utils.getCountriesFromD3NestResult(raws);
            const sites = utils.getSitesFromD3NestResult(raws, countries);

            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.complianceDataByParticipant = raws;
            this.completionDataByParticipant = raws;
            this.dataLoaded.complianceDataByParticipant = true;
            this.dataLoaded.completionDataByParticipant = true;
          }
        });
      }
    }
  },

  methods: {
    async getNonComplianceRateVSRetentionRate() {
      if (this.complianceWidgets) {
        this.loading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };
        const body = {};

        if (this.fromDate) {
          body.fromDate = this.fromDate;
          body.toDate = this.toDate;
        }

        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          body.participantsIds = this.participantsSelected;
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          body.siteId = this.specificSiteId[0];
        }

        const data = await this.$api.getNonComplianceRateVSRetentionRate(params, body);

        if (data.ok) {
          let result = data.body;

          if (result.data !== {}) {
            response = result.data;
          }
        }

        this.isLoading = false;
        return response;
      }
    },
    async getNewQueries() {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      // if (this.fromDate) {
      //   params.fromDate = this.fromDate;
      //   params.toDate = this.toDate;
      // }
      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        params.participantsIds = convertArrToString(this.participantsSelected);
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }

      const data = await this.$api.getQueriesEndpoint(params);

      if (data.ok) {
        response = _get(data, "body.data.activities", null);
      }

      this.isLoading = false;
      return response;
    },
    async getVisOverallEnrollementData(filterBy = null) {
      this.isLoading = true;
      let response = null;

      const params = {
        studyId: this.studyId
      };
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      if (this.fromDate) {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }
      if (filterBy === "country" && !(this.countrySelected[0] === "all" || this.countrySelected === "all")) {
        let countryIds = this.getCountryIds(this.countrySelected);
        params.countryIds = utils.convertArrToString(countryIds);
      } else if (filterBy === "site" && this.sitesSelected[0] !== "all") {
        let siteIds = this.getSiteIds(this.sitesSelected);
        params.siteIds = utils.convertArrToString(siteIds);
      } else if (filterBy === "participant" && this.participantsSelected[0] !== "all") {
        params.participantIds = utils.convertArrToString(this.participantsSelected);
      }
      let responseData = await this.$api.getEnrollmentParticipantData(params);
      if (responseData.ok) {
        response = _get(responseData, "body.data", null);
      }

      this.isLoading = false;
      return response;
    },
    getCountryIds(countryNames) {
      let countryIds = [];
      countryNames.map(countryName => {
        this.sitesDetails.forEach(site => {
          if (site.countryList[0].countryName === countryName) {
            countryIds.push(site.countryList[0].countryId);
          }
        });
      });
      countryIds = [...new Set(countryIds)];
      return countryIds;
    },
    getSiteIds(siteNames) {
      let siteIds = [];
      siteNames.map(siteName => {
        this.sitesDetails.forEach(site => {
          if (site.name === siteName) {
            siteIds.push(site.id);
          }
        });
      });
      return siteIds;
    },
    async getComplianceData() {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }
        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        const data = await this.$api.getCompliance(params);
        if (data.ok) {
          try {
            response = d3.csvParse(data.body);
            response = d3
              .nest()
              .key(d => d.date)
              .sortKeys(d3.ascending)
              .key(d => d.countryName)
              .sortKeys(d3.ascending)
              .key(d => d.siteName)
              .sortKeys(d3.ascending)
              .entries(response);
          } catch (error) {
            return null;
          }
        }

        this.isLoading = false;
        return response;
      }
    },
    async getParticipantComplianceData() {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }
        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        params.groupBy = "participant";
        const data = await this.$api.getCompliance(params);
        if (data.ok) {
          try {
            response = d3.csvParse(data.body);
            response = d3
              .nest()
              .key(d => d.date)
              .sortKeys(d3.ascending)
              .key(d => d.countryName)
              .sortKeys(d3.ascending)
              .key(d => d.siteName)
              .sortKeys(d3.ascending)
              .entries(response);
          } catch (error) {
            return null;
          }
        }

        this.isLoading = false;
        return response;
      }
    },
    async getParticipantStatusEndpoints() {
      this.isLoading = true;
      let response = {
        locations: null,
        boundaries: null
      };
      const params = {
        studyId: this.studyId
      };
      if (this.fromDate) {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }
      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        params.participantsIds = convertArrToString(this.participantsSelected);
      }
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }

      const data = await this.$api.getParticipantStatusVisData(params);

      if (data.ok) {
        let result = data.body;

        if (!_isEmpty(result.data)) {
          if (_has(result, "data.locations")) {
            response.locations = _get(result, "data.locations", null);
          }
        }
      }

      this.isLoading = false;
      return response;
    },

    getSelectedPage(value) {
      this.leftHeaderTextValue = value;
      switch (value) {
        case "Study Enrollment Dashboard":
          this.$router.push({
            name: "vis-enrollment",
            params: { studyId: this.studyId }
          });
          break;
        case "Study Compliance Dashboard":
          this.$router.push({
            name: "vis-compliance",
            params: { studyId: this.studyId }
          });
          break;
        case "Overall Study Executive Dashboard":
          break;
        case "Study Completion Dashboard":
          break;
        case "Activity and Overall Engagement Dashboard":
          break;
        case "Data Management Dashboard":
          this.$router.push({ name: "vis-data-management", params: { studyId: this.studyId } });
          break;
        case "Study Executive Dashboard":
          this.$router.push({ name: "vis-study-executive", params: { studyId: this.studyId } });
          break;
      }
    },
    getRangeMonth(payload) {
      this.filter("date", payload);
    },
    getSiteData(rawData, searchKeyword, filterKey = "name", responseKey = "userSiteId") {
      const siteData = _.find(rawData, allSitesWithDetails => {
        return allSitesWithDetails[filterKey] === searchKeyword;
      });
      return _.get(siteData, responseKey, "");
    },
    getDataFromCountry(payload) {
      this.filter("country", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },
    getDataFromSite(payload) {
      this.filter("site", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },
    getParticipantsDataFromCheckbox(payload) {
      this.filter("participant", payload.isCheckAll ? "all" : payload);
    },
    fetchedParticipants(payload) {
      this.siteListInParticipants = payload;
    },
    async filter(triggerBy, filterValue, detailSite) {
      switch (triggerBy) {
        case "country":
          const payload = {
            countries: {
              ...this.studyEnrollmentRawData,
              ...this.rawParticipantStatus
            },
            countriesByD3Nest: [...this.complianceData, ...this.complianceDataByParticipant]
          };
          const countrySelected = filterValue === "all" ? this.countryList : filterValue;
          this.sitesSelected = utils.getAllSitesWhenFilteringCountry(payload, countrySelected);
          this.countrySelected = filterValue === "all" ? ["all"] : filterValue;
          // this.allSitesList = StdEx.generateSites(this.rawParticipantStatus, filterValue)
          // this.sitesSelected = filterValue === 'all' ? ['all'] : this.allSitesList;

          break;
        case "site":
          this.sitesSelected = filterValue === "all" ? ["all"] : filterValue;
          if (filterValue === "all") {
            this.countrySelected = "all";
          } else {
            let selectedCountries = [];
            let locations = _get(this.tmpStudyEnrollmentRawData, "locations", null);
            filterValue.forEach(siteName => {
              Object.keys(locations).forEach(location => {
                if (Object.keys(locations[location]).includes(siteName) && !selectedCountries.includes(location)) {
                  selectedCountries.push(location);
                }
              });
            });
            this.countrySelected = selectedCountries;
          }
          break;
        case "date": {
          this.monthSelected = filterValue;

          this.fromDate = this.fromDate = filterValue[0].value;
          this.toDate = this.toDate = filterValue[1].value;

          if (this.fromDate === this.firstFromDate && this.toDate === this.firstToDate) {
            this.fromDate = null;
            this.toDate = null; // Reset date to default value
          }
          break;
        }
        case "participant": {
          this.participantsSelected = filterValue === "all" ? ["all"] : filterValue.checkedParticipants;
          if (this.participantsSelected && this.participantsSelected.length === 0) {
            this.setToEmptyData();
            return;
          }
          this.isLoading = false;
          break;
        }
        default:
          break;
      }
      await this.callApi(true, triggerBy);
      this.filterTriggered = !this.filterTriggered;
    },
    async getBrandingDetails() {
      try {
        const data = await this.$api.getBrandingDetailsFact(this.studyId);
        if (data.ok) {
          return data.body;
        } else {
          return null;
        }
      } catch (err) {
        return null;
      }
    },
    async prepareDatePicker() {
      const d = new Date();
      this.todaysDate = moment.utc(d).format("DD MMM YYYY");
      const studyData = this.studyData;
      const studyStartDate = studyData.studyStartDate;
      const datePicker = [];
      const tmpPicker = [];
      for (let m = moment(studyStartDate); m.diff(moment(), "months") <= 0; m.add(1, "months")) {
        datePicker.push(m.format("MMM YYYY"));
        tmpPicker.push(m.format("YYYY-MM-DD"));
      }
      this.dataPicker = datePicker;
      const firstMonth = this.dataPicker[0];
      const lastMonth = this.dataPicker[this.dataPicker.length - 1];
      this.monthSelected = [firstMonth, lastMonth];
    },
    setToEmptyData() {
      this.rawParticipantStatus = null;
      this.complianceData = null;
      this.completionData = null;
      this.complianceDataByParticipant = null;
      this.completionDataByParticipant = null;
      this.studyEnrollmentRawData = {};
    },
    async turnOffGlobalLoader() {
      let query = Object.assign({}, this.$route.query);
      delete query.automatic_off_loader;
      this.$router.replace({ query });
      this.$store.commit("SHOW_LOADER", false);
    },
    async getSiteDetails() {
      if (this.sitesData && this.sitesData.length > 0 && this.checkCurrentSiteOrStudy) {
        return this.sitesData;
      } else {
        let response = [];
        let responseData = await this.$api.getSitesFact(this.studyId);
        if (responseData.ok) {
          response = _get(responseData, "body", null);
          this.$store.dispatch("saveSitesData", response);
          this.$store.dispatch("saveStudyId", this.studyId);
          commonHelper.setSiteId();
        }
        return response;
      }
    },
    async callApi(turnOffGlobalLoader = false, filterBy) {
      let apiPromises = [];
      let newCountries = [];
      let newSites = [];

      if (["date"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          this.getParticipantStatusEndpoints().then(data => {
            const countries = utils.getCountries(data.locations);
            const sites = utils.getSites(data.locations, countries);
            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.rawParticipantStatus = data.locations;

            this.dataLoaded.rawParticipantStatus = true;
          }),
          this.getNonComplianceRateVSRetentionRate().then(raws => {
            if (raws) {
              const countries = utils.getCountries(raws);
              const sites = utils.getSites(raws, countries);
              this.tmpCountries = this.tmpCountries.concat(countries);
              this.tmpSites = this.tmpSites.concat(sites);
              this.nonComplianceRateVSRetentionRateData = raws;
              this.dataLoaded.nonComplianceRateVSRetentionRate = true;
            }
          })
        ]);
      }
      if (["mounted"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          this.getComplianceData().then(raws => {
            if (raws) {
              const countries = utils.getCountriesFromD3NestResult(raws);
              const sites = utils.getSitesFromD3NestResult(raws, countries);

              this.tmpCountries = this.tmpCountries.concat(countries);
              this.tmpSites = this.tmpSites.concat(sites);
              this.complianceData = raws;
              this.completionData = raws;
              this.dataLoaded.completionData = true;
              this.dataLoaded.complianceData = true;
            }
          }),
          this.getParticipantStatusEndpoints().then(data => {
            const countries = utils.getCountries(data.locations);
            const sites = utils.getSites(data.locations, countries);
            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.rawParticipantStatus = data.locations;

            this.dataLoaded.rawParticipantStatus = true;
          }),
          this.getParticipantComplianceData().then(raws => {
            if (raws) {
              const countries = utils.getCountriesFromD3NestResult(raws);
              const sites = utils.getSitesFromD3NestResult(raws, countries);

              this.tmpCountries = this.tmpCountries.concat(countries);
              this.tmpSites = this.tmpSites.concat(sites);
              this.complianceDataByParticipant = raws;
              this.completionDataByParticipant = raws;
              this.dataLoaded.complianceDataByParticipant = true;
              this.dataLoaded.completionDataByParticipant = true;
            }
          }),
          this.getVisOverallEnrollementData().then(raw => {
            const countries = utils.getCountries(raw.locations);
            const sites = utils.getSites(raw.locations, countries);

            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.studyEnrollmentRawData = raw;
            this.tmpStudyEnrollmentRawData = raw;
            this.dataLoaded.studyEnrollmentRawData = true;
          }),
          this.getSiteDetails().then(sites => {
            this.sitesDetails = sites;
          }),
          this.getNonComplianceRateVSRetentionRate().then(raws => {
            if (raws) {
              const countries = utils.getCountries(raws);
              const sites = utils.getSites(raws, countries);
              this.tmpCountries = this.tmpCountries.concat(countries);
              this.tmpSites = this.tmpSites.concat(sites);
              this.nonComplianceRateVSRetentionRateData = raws;
              this.dataLoaded.nonComplianceRateVSRetentionRate = true;
            }
          })
        ]);
      }
      if (["participant", "site", "country"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          await this.getParticipantStatusEndpoints().then(data => {
            const countries = utils.getCountries(data.locations);
            const sites = utils.getSites(data.locations, countries);
            newCountries = newCountries.concat(countries);
            newSites = newSites.concat(sites);
            this.rawParticipantStatus = data.locations;

            this.dataLoaded.rawParticipantStatus = true;
          }),
          await this.getComplianceData().then(raws => {
            if (raws) {
              const countries = utils.getCountriesFromD3NestResult(raws);
              const sites = utils.getSitesFromD3NestResult(raws, countries);

              newCountries = newCountries.concat(countries);
              newSites = newSites.concat(sites);
              this.complianceData = raws;
              this.completionData = raws;
              this.dataLoaded.completionData = true;
              this.dataLoaded.complianceData = true;
            }
          }),
          await this.getParticipantComplianceData().then(raws => {
            if (raws) {
              const countries = utils.getCountriesFromD3NestResult(raws);
              const sites = utils.getSitesFromD3NestResult(raws, countries);

              newCountries = newCountries.concat(countries);
              newSites = newSites.concat(sites);
              this.complianceDataByParticipant = raws;
              this.completionDataByParticipant = raws;
              this.dataLoaded.complianceDataByParticipant = true;
              this.dataLoaded.completionDataByParticipant = true;
            }
          }),
          await this.getVisOverallEnrollementData(filterBy).then(raw => {
            this.studyEnrollmentRawData = raw;
            this.dataLoaded.studyEnrollmentRawData = true;
          }),
          await this.getNonComplianceRateVSRetentionRate().then(raws => {
            if (raws) {
              const countries = utils.getCountries(raws);
              const sites = utils.getSites(raws, countries);
              newCountries = newCountries.concat(countries);
              newSites = newSites.concat(sites);
              this.nonComplianceRateVSRetentionRateData = raws;
              this.dataLoaded.nonComplianceRateVSRetentionRate = true;
            }
          })
        ]);
      }
      await Promise.all(apiPromises);
      if (["participant"].includes(filterBy)) {
        this.countrySelected = [...new Set(newCountries)];
        this.sitesSelected = [...new Set(newSites)];
      }
      this.callApiCompleted = true;
      if (turnOffGlobalLoader) {
        await this.turnOffGlobalLoader();
      }
    }
  },
  computed: {
    ...mapGetters(["user", "sitesData", "studyIdValue", "selectedSiteId"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    isMapsApiAvailable() {
      let notAvailableDomains = [".cn"];
      let hostname = window.location.hostname;
      if (hostname.lastIndexOf(".") == -1) {
        return true;
      }
      let domainEnding = hostname.substring(hostname.lastIndexOf("."));
      return !(notAvailableDomains.indexOf(domainEnding) > -1);
    },
    getSiteId() {
      return localStorage.getItem("selectedSite");
    },
    isSiteRole() {
      return commonHelper.isSiteUser(this.user.userRole);
    },
    checkCurrentSiteOrStudy() {
      return this.studyIdValue === this.studyId && (!this.isSiteRole || (this.isSiteRole && this.getSiteId === this.selectedSiteId));
    }
  },
  async mounted() {
    this.$router.push({ query: { automatic_off_loader: false } });
    this.studyId = this.$route.params.studyId;
    await this.prepareDatePicker();

    this.specificSiteId = _get(this.user, "siteIds", []);
    await this.callApi(true, "mounted");
    await this.turnOffGlobalLoader();
  }
};
</script>
